var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"base-row-padded"},[_c('b-col',[_c('PlaylistsViewer',{attrs:{"playlist-type":'weekly-playlists'}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }